import styled from 'styled-components';

const PRIMARY_COLOR = '#4948ac';

export const MainContainer = styled.div`
  width: 100%
  padding: 24px 32px;
  font-family: 'Inter', sans-serif;
  color: #333;
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const SearchLink = styled.span`
  font-size: 1.4rem;
  color: ${PRIMARY_COLOR};
  cursor: pointer;
`;

export const ViewHistory = styled.span`
  font-size: 1.4rem;
  color: ${PRIMARY_COLOR};
  cursor: pointer;
`;

export const InvoiceTitle = styled.h1`
  font-size: 2.8rem;
  font-weight: 400;
  margin: 8px 0;
`;

export const SubText = styled.div`
  font-size: 1.4rem;
  color: ${PRIMARY_COLOR};
  margin-bottom: 24px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 80px;
  row-gap: 14px;
`;

export const InfoRow = styled.div`
  display: flex;
`;

export const Label = styled.div`
  width: 180px;
  font-weight: 600;
  color: #555;
  font-size: 1.4rem;
`;

export const Value = styled.div`
  color: #666;
  font-size: 1.4rem;
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusDot = styled.span`
  width: 12px;
  height: 12px;
  background: ${PRIMARY_COLOR};
  border-radius: 50%;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #ddd;
  margin: 24px 0;
`;

export const AmountGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 12px;
`;

export const NotesBox = styled.textarea`
  width: 100%;
  height: 120px;
  padding: 12px;

  background: #f3f3f3;
  border: 1px solid #d1d1d1;
  border-radius: 4px;

  resize: none;
  margin-top: 8px;

  font-family: inherit;
  font-size: 1.4rem;
  color: #333;

  &:focus {
    outline: none;
    border-color: #4948ac;
    box-shadow: 0 0 0 1px rgba(73, 72, 172, 0.2);
  }
`;

export const Attachment = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  color: ${PRIMARY_COLOR};
  cursor: pointer;
`;

export const AttachmentIcon = styled.div`
  width: 32px;
  height: 32px;
  background: ${PRIMARY_COLOR};
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
`;
